import { BASE_PATH } from './constants';

export const isDevBox = (): boolean => process.env.NEXT_PUBLIC_IS_DEV_BOX === 'true';
export const isDevEnvironment = (): boolean => process.env.NEXT_PUBLIC_ENV === 'development';
export const isTestEnvironment = (): boolean => process.env.NEXT_PUBLIC_ENV === 'test';
export const isStagingEnvironment = (): boolean => process.env.NEXT_PUBLIC_ENV === 'staging';
export const isProdEnvironment = (): boolean => process.env.NEXT_PUBLIC_ENV === 'production';
export const getEnvironment = (): string => process.env.NEXT_PUBLIC_ENV ?? 'development';

/**
 * Safe environment variable wrappers
 *
 * NOTE: Please use these functions for type safety and null checking
 */

export const getGqlApiUrl = (): string => {
  if (process.env.NEXT_PUBLIC_GQL_API_URL) return process.env.NEXT_PUBLIC_GQL_API_URL;
  throw new Error('process.env.NEXT_PUBLIC_GQL_API_URL is not set!');
};

export const getFrontEndUrl = ({ withBasePath = false }: { withBasePath?: boolean } = {}): string => {
  if (process.env.NEXT_PUBLIC_FRONT_END_URL) {
    return process.env.NEXT_PUBLIC_FRONT_END_URL + (withBasePath ? BASE_PATH : '');
  }
  throw new Error('process.env.NEXT_PUBLIC_FRONT_END_URL is not set!');
};

export const getBaseImagePath = (): string => {
  if (process.env.NEXT_PUBLIC_BASE_IMAGE_PATH) return process.env.NEXT_PUBLIC_BASE_IMAGE_PATH;
  throw new Error('process.env.NEXT_PUBLIC_BASE_IMAGE_PATH is not set!');
};

export const getBlogUrl = (): string => {
  if (process.env.NEXT_PUBLIC_BLOG_URL) return process.env.NEXT_PUBLIC_BLOG_URL;
  throw new Error('process.env.NEXT_PUBLIC_BLOG_URL is not set!');
};

export const getThumborEndpoint = (): string => {
  if (process.env.NEXT_PUBLIC_THUMBOR_ENDPOINT) return process.env.NEXT_PUBLIC_THUMBOR_ENDPOINT;
  throw new Error('process.env.NEXT_PUBLIC_THUMBOR_ENDPOINT is not set!');
};
